import axiosInstance from "auth/FetchInterceptor";
import { APPOINTMENT_API } from "constants/ApiConstant";
import { HOSPITAL_MANAGER_API } from "constants/ApiConstant";
import { DOCTOR_MANAGEMENT_API } from "constants/ApiConstant";
const AppointmentService = {};

AppointmentService.getAllHospital = function () {
  return axiosInstance.get(`${HOSPITAL_MANAGER_API}/get-all`, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

AppointmentService.getAllDoctor = function () {
  return axiosInstance.get(`${DOCTOR_MANAGEMENT_API}/mobile/get-all`, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

AppointmentService.searchGrid = function (data) {
  return axiosInstance.post(`${APPOINTMENT_API}/search-grid`, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

AppointmentService.getAppointmentById = function (id) {
  return axiosInstance.get(`${APPOINTMENT_API}/mobile/get-by-id?id=${id}`, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

AppointmentService.create = function (data) {
  return axiosInstance.post(APPOINTMENT_API, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

AppointmentService.update = function (data) {
  return axiosInstance.put(`${APPOINTMENT_API}/update`, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

AppointmentService.delete = function (id) {
  return axiosInstance.delete(`${APPOINTMENT_API}?id=${id}`, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

AppointmentService.changeStateAppointment = function (data) {
  return axiosInstance.put(`${APPOINTMENT_API}/change-state`, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};

AppointmentService.getDSKhoaPhuTrach = function (id) {
  return axiosInstance.get(
    `${APPOINTMENT_API}/danh-sach-khoa-phu-trach?id=${id}`,
    {
      baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    }
  );
};

AppointmentService.exportDSHenKhamLai = function (data) {
  return axiosInstance.post(`${APPOINTMENT_API}/hen-kham-lai/export`, data, {
    baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
  });
};
export default AppointmentService;
